import { IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';
import { ICashFlowFLI } from './ICashFlowFLI.interface';

export interface ICashFlowOperatingActivitiesComponentInput {
    title: string;
    flis: ICashFlowFLI[];
    profitOfTheYearFli: IAccountMappingTemplateGroupItemFLI;
    currentAnnualProfit: number;
    previousAnnualProfit: number;
    currentYearDate: string;
    previousYearDate: string;
    currency: string;
}
